import Utils from "../../../../../shared/utils";

export const IMAGE_URL = Utils.buildProductPageImageLink("rent/safecheck/third-section.svg")

export const MOUSE_ANIMATION = Utils.buildProductPageImageLink("rent/safecheck/mouse-animation.svg")